import tinycolor from 'tinycolor2'
import tinygradient from 'tinygradient'
import dark from './themes/dark'
import light from './themes/light'

export const themes = {
  standard: light,
  dark,
  light
}

/**
 * @type {Array} the themes list
 */
export const themesList = Object.keys(themes).map(key => {
  const theme = themes[key]
  const gradient = tinygradient(
    theme.colors.colorBg2.value,
    theme.colors.colorBg1.value,
    theme.colors.colorA.value
  )

  return {
    key,
    label: key,
    gradient: gradient.css('linear', 'to top')
  }
})

/**
 * The current theme
 */
const theme = Object.keys(themes.standard.colors).reduce((res, key) => {
  const hex = tinycolor(themes.standard.colors[key].value)

  // Prevent alpha hex values from applying in GLSL
  hex.setAlpha(1)

  res[key] = themes.standard.colors[key].value

  return res
}, {})

/**
 * The theme uniforms
 */
export const themeUniforms = {
  uBorderRadius: { value: 10 },
  uBorderRadiusSmall: { value: 7 },
  uStrokeThickness: { value: 1 }
}

const createStyleNode = container => {
  const node = document.createElement('style')

  container.appendChild(node)

  return node
}

export const watchers = []

/**
 * Set the theme
 *
 * @param {string} nextTheme - the next theme key
 * @param {HTMLElement} root - the root node to apply the theme state to
 */
export const applyTheme = (nextTheme, root) => {
  const targetTheme = themes[nextTheme]

  if (!targetTheme) {
    console.error('Theme does not exist:', nextTheme)

    return
  }

  root.styleNode = root.styleNode || createStyleNode(root)

  const styles = []

  Object.keys(theme).forEach(key => {
    const nextColor = targetTheme.colors[key]

    if (!nextColor) {
      console.warn('Key for theme does not exist:', key)

      return
    }

    const parsedColor = tinycolor(nextColor.value)
    const hsl = parsedColor.toHsl()

    // Prevent alpha hex values from applying in GLSL
    parsedColor.setAlpha(1)

    styles.push(
      `--${nextColor.key}: ${parsedColor.toHslString()};`,
      `--${nextColor.key}-hsl: ${Math.round(hsl.h)}deg, ${Math.round(
        hsl.s * 100
      )}%, ${Math.round(hsl.l * 100)}%;`,
      `--${nextColor.key}-h: ${Math.round(hsl.h)}deg;`,
      `--${nextColor.key}-s: ${Math.round(hsl.s * 100)}%;`,
      `--${nextColor.key}-l: ${Math.round(hsl.l * 100)}%;`
    )

    theme[key] = nextColor.value
  })

  const attributes = targetTheme.attributes || {}

  Object.keys(attributes).forEach(key => {
    styles.push(`${key}: ${attributes[key]};`)
  })

  root.styleNode.innerHTML = `:root {\r${styles.join('\r')}\r}`
  document.documentElement.dataset.theme = nextTheme

  watchers.forEach(watcher => watcher(theme))
}

export default theme
